<template>
  <v-dialog
    v-model="display"
    max-width="340px"
    persistent
    content-class="first-login-dialog"
  >
    <v-card
      color="card"
      max-height="420px"
      class="card"
    >
      <h2>{{ $t('first_login_dialog.settings') }}</h2>
      <v-text-field
        v-model="email"
        :label="$t('first_login_dialog.email_address')"
        placeholder="johndoe@gmail.com"
        type="email"
        outlined
        :error-messages="v$.email.$error ? [$t('first_login_dialog.invalid_email')] : []"
      />
      <div class="final-row-dialog">
        <LocaleSelector />
        <v-btn
          color="primary"
          class="mt-4"
          @click="save"
        >
          {{ $t('first_login_dialog.save') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import LocaleSelector from '@/components/LocaleSelector.vue';
import UserService from '@/services/user.service.js';
import { useAuthStore } from '@/store/auth.module';
import { useUserStore } from '@/store/user.module';
import { required, email } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export default {
  name: 'FirstLoginDialog',
  components: {
    LocaleSelector,
  },
  data() {
    return {
      email: null,
      v$: useVuelidate(),
    };
  },
  validations: {
      email: { required, email },
  },
  computed: {
    locale() {
      const authStore = useAuthStore();
      return authStore.getLocale;
    },
    user() {
      const userStore = useUserStore();
      return userStore.currentUser;
    },
    isSettingsComplete() {
      return this.user?.isSettingsCompleted();
    },
    display(){
      return !this.isSettingsComplete;
    }
  },
  created() {
    this.$v = useVuelidate(this.validations, this);
  },
  methods: {
    save() {
      this.v$.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const userStore = useUserStore();
      userStore.settingsComplete({
        email: this.email,
        locale: this.locale,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  padding: 40px;
  gap: 10px;
  .v-text-field{
    width: 100%;
  }
  .final-row-dialog{
    display: flex;
    width: 100%;
    align-items: end;
    justify-content: space-between;
    .locale-selector{
      width: auto;
      margin-left: 0 !important;
    }
  }
}
</style>
